import { useEffect, useRef, useState } from 'react';
import Search from "components/Email/Search";
import Form from "components/Email/Form";
import Table from "components/Email/Table";
import { useEmail } from 'hooks/useEmail';
import { useCliente } from 'hooks/useCliente';

import {Modal} from "react-bootstrap";
import SpinnerBootrap from 'components/SpinnerBootrap';
import SearchModal from 'components/Email/SearchModal';
import TableModal from 'components/Email/TableModal';
import Table2Modal from 'components/Email/Table2Modal';


function Email() {
    const [modalVincularCliente, setModalVincularCliente] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState({})

    const {
        allEmails,
        emails,
        loading: loadingEmail,
        page: pageEmail,
        totalPages: totalPagesEmail,
        status: statusEmail,
        deleteEmail,
        updateEmail,
        createEmail,
        getEmails,
        setPage: setPageEmail,
        itemsPerPage,
        setItemsPerPage,
    } = useEmail();


    const {
        getVinculedClientsOfEmail,
        clientes,
        vinculedClientes,
        loading: loadingCliente,
        page: pageCliente,
        totalPages: totalPagesCliente,
        status: statusCliente,
        getClientes,
        unlikeClientOfEmail,
        likeClientToEmail,
        setPage: setPageCliente
    } = useCliente();


    const [isSearchedCliente, setIsSearchedCliente] = useState({
        search: '',
        option: '',
        state: false
    })

    
    const [isSearchedEmail, setIsSearchedEmail] = useState({
        search: '',
        option: '',
        state: false
    })

    const searchFormRef = useRef();
    
     const resetSearch = () => {
        setIsSearchedEmail({
            search: '',
            option: '',
            state: false
        })
        searchFormRef.current?.reset();
     }

    const desvinculedClient = async ({cliente}) => {
        const numDocument = await unlikeClientOfEmail({email: selectedEmail, cliente});
        if(numDocument){
            await getVinculedClientsOfEmail({email: selectedEmail, numDocument})
            await getEmails({})
        }
    }

    const vinculedClient = async ({cliente}) => {
        const numDocument = await likeClientToEmail({email: selectedEmail, cliente});
        if(numDocument){
            await getVinculedClientsOfEmail({email: selectedEmail,  numDocument})
            await getEmails({})
        }
    }

    const handleHideModalVincularCliente = () => {
        setSelectedEmail({});
        setModalVincularCliente(false);
    }
    
    useEffect(() => {
        if (statusEmail !== 401 || statusCliente !== 401) return
        localStorage.removeItem('token')
        window.location.href = "/login"
    }, [statusEmail, statusCliente])

    return (
        <div className="container">
            <div className="row my-md-4">
                <h4 className="d-flex justify-content-center">Gestor de Correos</h4>
                <div className="col-12">
                    <Search getEmails={getEmails} setIsSearched={setIsSearchedEmail} formRef={searchFormRef}/>
                </div>
                <div className="col-12">
                    <Form createEmail={createEmail} updateEmail={updateEmail} setIsSearched={setIsSearchedEmail} />
                </div>
                <div className="col-12">
                    {loadingEmail && <SpinnerBootrap />}
                    <Table 
                        setSelectedEmail={setSelectedEmail}
                        getVinculedClientsOfEmail={getVinculedClientsOfEmail}
                        setModalVincularCliente={setModalVincularCliente}
                        emails={emails}
                        getEmails={getEmails}
                        deleteEmail={deleteEmail}
                        totalPages={totalPagesEmail}
                        setPage={setPageEmail}
                        page={pageEmail}
                        isSearched={isSearchedEmail}
                        setIsSearched={setIsSearchedEmail}
                        hasSearched={isSearchedEmail.state}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        resetSearch={resetSearch}
                        totalEmails={allEmails?.length ?? 0}
                    />
                </div>
            </div>

            <Modal show={modalVincularCliente} onHide={handleHideModalVincularCliente}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Clientes</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <div className="col-12">
                        <SearchModal getClientes={getClientes} setIsSearched={setIsSearchedCliente}/>
                    </div>
                    <div className="col-12">
                        {loadingCliente && <SpinnerBootrap/>}
                        <TableModal vinculedClient={vinculedClient} clientes={clientes} getClientes={getClientes} totalPages={totalPagesCliente} setPage={setPageCliente} page={pageCliente} isSearched={isSearchedCliente} setIsSearched={setIsSearchedCliente} />                        
                    </div>
                    
                    <div className="col-12">
                        {loadingCliente && <SpinnerBootrap/>}
                        
                        <Table2Modal
                            vinculedClientes={vinculedClientes}
                            desvinculedClient={desvinculedClient} 
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    )
}

export default Email